module.exports = __webpack_public_path__ + "static/media/Piercing-belly-bottom.e4c27290.png";